<ng-container>
  <app-modal [width]="modalWidth$ | async" [classType]="'white'" [zindex]="3">
    <div content>

      <div class="header">
        <div class="icon-content">
          <i aria-hidden="true" class="icon-close" (click)="toggleNotification.emit()"></i>
        </div>
      </div>

      <div class="icon-notification-content">
        <img class="icon-notification" loading="lazy" [src]="ALERT_NOTIFICATION | ImageCdn">
      </div>

      <div class="message-content">
        <span class="principal">
          {{ titleKey | transloco }}
        </span>
        <span class="secondary">
          {{ 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.CREATED_EDITED_DESCRIPTION' | transloco }}
        </span>
      </div>

    </div>
  </app-modal>
</ng-container>
